import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Switch, Route } from 'react-router-dom';
import { Container } from 'reactstrap';

import Category from '../components/Category/Category';
import ChannelList from '../components/ChannelList/ChannelList';
import ShowList from '../components/ShowList/ShowList';
import Account from '../components/Account/Account';
import Favorites from '../components/Favorites/Favorites';
import PlayChannel from '../components/Play/PlayChannel';
import PlayVideo from '../components/Play/PlayVideo';
import PlayOther from '../components/Play/PlayOther';
import SearchPage from '../components/SearchPage/SearchPage';
import SmartTV from '../components/SmartTV/SmartTV';
import SmartTVGuide from '../components/SmartTVGuide/SmartTVGuide';
import ClaimGadget from '../components/ClaimGadget/ClaimGadget';
import History from '../components/History/History';
import Panoramic from '../components/Panoramic/Panoramic';
import PanoramicView from '../components/Panoramic/PanoramicView';
import StaticPages from '../components/StaticPages/StaticPages';
import Domain from '../components/Domain/Domain';
import Country from '../components/Country/Country';
import AddCountryLanguage from '../components/Country/AddCountryLanguage';
import FlashMessage from '../components/FlashMessage/FlashMessage';
import SearchPagefor360 from '../components/SearchPage/SearchPagefor360';
import { show, hide } from '../actions/ActivityIndicatorActions';
import { searchText } from '../actions/SearchActions';
import { parseQueryString } from '../utils/helper';
import Login from '../components/Login/Login';
import LoginWithUsername from '../components/Login/LoginWithUsername';
import LoginWithPassword from '../components/Login/LoginWithPassword';
import ForgotPassword from '../components/Login/ForgotPassword';
import ChangePassword from '../components/Login/ChangePassword';
import RegisterForm from '../components/Register/RegisterForm';
import ThankYouPage from '../components/Register/ThankYouPage';
import PrivateRoute from './../PrivateRoute'
import ContactUs from './../components/ContactUs/ContactUs';
import { config } from '../constants/domainConfig';
class Home extends Component {
    constructor(props) {
        super(props);
        this.goToPage = this.goToPage.bind(this);
    }

    componentWillMount() {
        
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextProps) {
        
    }

    goToPage(path) {
        if (this.props.location.pathname != path) {
            this.props.history.push(path);
        }
    }

    render() {
        if (this.props.search.searchText != "") {
            return(
                <SearchPage goToPage={this.goToPage} path={this.props.location.pathname}/>
            )
        } else {
            return (
                <main className="home main">
                    <FlashMessage path={this.props.location.pathname}/>
                    <Container>
                        <Switch>
                            <Route path="/domain" name="Domain" component={Domain}/>
                            <Route path="/country" name="Country" component={Country}/>
                            <Route path="/manage-country" name="Country Language" component={AddCountryLanguage}/>
                        </Switch>
                    </Container>
                    <Switch>
                        <Route path="/category" name="CategoryPage" component={Category}/>
                        <PrivateRoute path="/channels/:id" name="ChannelList" component={ChannelList}/>
                        <PrivateRoute path="/movies/:id" name="ShowList" component={ShowList}/>
                        <PrivateRoute path="/videos/:id" name="VideoList" component={ChannelList}/>
                        <PrivateRoute path="/account" name="Account" component={Account}/>
                        <PrivateRoute path="/favorites" name="Favorites" component={Favorites}/>
                        <PrivateRoute path="/play/channel" name="Play Channel" component={PlayChannel}/>
                        <PrivateRoute path="/play/video" name="Play Channel" component={PlayVideo}/>
                        <PrivateRoute path="/show" name="Play" component={PlayOther}/>
                        <PrivateRoute path="/smartTv" name="SmartTV" component={SmartTV}/>
                        <PrivateRoute path="/all/:id" name="SmartTVGuide" component={SmartTVGuide}/>
                        <PrivateRoute path="/history" name="History" component={History}/>
                        <PrivateRoute path="/panoramic" name="Panoramic" component={Panoramic}/>
                        <PrivateRoute path="/panoramic-show/:catId/:imageId" name="Play" component={PanoramicView}/>
                        <PrivateRoute path="/claim-gadget" name="ClaimGadget" component={ClaimGadget}/>
                        <PrivateRoute path="/about" name="About" component={StaticPages}/>
                        <PrivateRoute path="/privacy-policy" name="PrivacyPolicy" component={StaticPages}/>
                        <PrivateRoute path="/terms-conditions" name="TermsConditions" component={StaticPages}/>
                        <PrivateRoute path="/search" name="Search" component={SearchPagefor360}/>
                        <PrivateRoute path="/ContactUs" name="/ContactUs" component={ContactUs}/>
                        <Route path="/loginWithEmailId" name='LoginPage' component={LoginWithPassword}/>
                        <Route path="/loginWithUsername" name='Login With Username' component={LoginWithUsername} /> 
                        <Route path="/forgot-password" name='ForgotPassword' component={ForgotPassword}/> 
                        <Route path="/reset-password/:token/:uid" name='ChangePassword' component={ChangePassword}/> 
                        <Route path="/verify" name='Thank You' component={ThankYouPage}/> 
                        <Route path="/register" name='Register' component={RegisterForm}/> 
                        <Route path="*" name='Login' component={Login}/>
                    </Switch>
                </main>
            )
        }
    }
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        account: state.AccountReducer,
        category: state.CategoryReducer,
        country: state.CountryReducer,
        domain: state.DomainReducer,
        favorite: state.FavoriteReducer,
        flashmessage: state.FlashMessageReducer,
        historyVideos: state.HistoryReducer,
        loader: state.ActivityIndicatorReducer,
        play: state.PlayReducer,
        search: state.SearchReducer,
        smartTV: state.SmartTVReducer,
        splash: state.SplashScreenReducer,
        user: state.AuthenticationReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        show,
        hide,
        searchText
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);


// WEBPACK FOOTER //
// ./src/containers/Home.js